import { matchPath, useLocation } from "react-router-dom";

import { appRoutes } from "../router/routerPaths";

// export const useMatchRoute = () => {
//   const { pathname } = useLocation();
//
//   const splitedPathname = pathname.split("/").filter(Boolean);
//
//   if (splitedPathname.length > 0 && !["uk"].includes(splitedPathname[0])) {
//     return Object.values(appRoutes())
//       .flat()
//       .find(route => matchPath({ path: route?.path }, pathname));
//   }
//
//   return Object.values(appRoutes())
//     .flat()
//     .find(route => matchPath({ path: route.path }, pathname));
// };

export const useMatchRoute = () => {
  const { pathname } = useLocation();

  const splitedPathname = pathname.split("/").filter(Boolean);

  const allRoutes = Object.values(appRoutes()).flat();

  if (splitedPathname.length > 0 && !["uk"].includes(splitedPathname[0])) {
    return allRoutes
      .sort((a, b) => (b.path?.length || 0) - (a.path?.length || 0))
      .find(route => matchPath({ path: route?.path }, pathname));
  }

  return allRoutes
    .sort((a, b) => (b.path?.length || 0) - (a.path?.length || 0))
    .find(route => matchPath({ path: route.path }, pathname));
};
